import React from "react";
import { Controller, Control } from "react-hook-form";
import SelectList from "react-select";
import { OptionType } from "../../common-components/TypesofInterfaces";



interface ControlledSelectProps {
  name: string;
  control: Control<any>;
  placeholder?: string;
  options?: OptionType[];
  isClearable?: boolean;
  onChange?: (value: OptionType | null) => void;
  className?: string;
}

const ControlledSelect: React.FC<ControlledSelectProps> = ({
  name,
  control,
  placeholder = "Select option",
  options,
  isClearable = true,
  onChange,
  className,
}) => {
  const wrapperClass = className ?? "w-full lg:max-w-[200px] lg:min-w-[200px] min-w-[170px] max-w-[170px]";
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className={wrapperClass}>
          <SelectList
            {...field}
            options={options}
            isClearable={isClearable}
            isOptionDisabled={(option: any) => option?.isDisabled === true}
            onChange={(selected) => {
              field.onChange(selected);
              if (onChange) onChange(selected);
            }}
            placeholder={placeholder}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            className="border border-solid border-neutral-300 font-poppins rounded-lg w-full font-normal  lg:text-[12px]  overflow-x-auto max-w-[200px]sm:text-[10px]"
            styles={{
              container: (provided) => ({
                ...provided,
                pointerEvents: "auto",
              }),
              input: (provided) => ({
                ...provided,
                position: field.value?.length ? "relative" : "absolute",
                pointerEvents: "auto",
                left: 6,
                marginRight: "10px",
                caretColor: "auto",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected || state.isFocused ? "#E6E6E6" : "",
                color: (state.data as any)?.isDisabled ? "#9ca3af" : "black",
                cursor: (state.data as any)?.isDisabled ? "default" : "pointer",
                pointerEvents: (state.data as any)?.isDisabled ? "none" : "auto",
              }),
              multiValue: (provided) => ({
                ...provided,
                height: "30px",
                display: "flex",
                alignItems: "center",
                borderRadius: "6px",
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 1050,
                position: "absolute",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              }),
              menuPortal: (provided) => ({
                ...provided,
                zIndex: 1050,
              }),
              valueContainer: (provided) => ({
                position: "relative",
                maxWidth: "28vw",
                width: "100%",
                paddingLeft: "6px",
                display: "flex",
                alignItems: "center",
                height: "40px",
                paddingRight: "8px",
                overflowX: "auto",
                overflowY: "hidden",
                minWidth: "50px",
                boxSizing: "border-box",
              }),
              control: (provided) => ({
                display: "flex",
                height: "40px",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }),
              menuList: (provided) => ({
                maxHeight: "100px",
                overflowY: "auto",
              }),
              clearIndicator: () => ({
                marginLeft: "1px",
                marginTop: "5px",
                color: "gray",
                cursor: "pointer",
              }),
            }}
          />
        </div>
      )}
    />
  );
};

export default ControlledSelect;
